import { render, staticRenderFns } from "./Accommodation-detail.vue?vue&type=template&id=c8a85ed8&scoped=true&"
import script from "./Accommodation-detail.vue?vue&type=script&lang=js&"
export * from "./Accommodation-detail.vue?vue&type=script&lang=js&"
import style0 from "./Accommodation-detail.vue?vue&type=style&index=0&id=c8a85ed8&scoped=true&lang=css&"
import style1 from "./Accommodation-detail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a85ed8",
  null
  
)

export default component.exports